<script lang="ts">
    import { configService } from '$lib/services';

    import { Feature } from '@shared/types';

    export let feature: Feature;

    $: isFeatureAllowed = configService.isFeatureAllowed(feature);
</script>

{#if isFeatureAllowed}
    <slot />
{:else}
    {#if $$slots.notAllowed}
        <slot name="notAllowed" />
    {/if}
{/if}
